<template>
  <v-layout row wrap justify-center>
    <v-flex xs12>
      <v-form>
        <v-card>
          <v-card-text class="pt-0">
            <v-layout row wrap>
              <v-flex xs12 sm12 md6 class="pa-2">
                <v-card-title class="subheading pl-0 pb-0"
                  >PENGATURAN DASAR</v-card-title
                >
                <v-divider></v-divider>
                <v-text-field
                  append-icon="computer"
                  type="text"
                  :disabled="!editting"
                  v-model="form.app_title"
                  v-validate="'required'"
                  name="app_title"
                  data-vv-name="app_title"
                  label="Judul Aplikasi"
                  data-vv-as="Judul Aplikasi"
                  :error-messages="errors.collect('app_title')"
                >
                </v-text-field>
                <v-text-field
                  append-icon="local_offer"
                  type="text"
                  :disabled="!editting"
                  v-model="form.app_version"
                  v-validate="'required'"
                  name="app_version"
                  data-vv-name="app_version"
                  label="Versi Aplikasi"
                  data-vv-as="Versi Aplikasi"
                  :error-messages="errors.collect('app_version')"
                >
                </v-text-field>
                <v-autocomplete
                  append-icon="palette"
                  attach
                  chips
                  :color="form.app_theme"
                  :items="colorsOption"
                  :disabled="!editting"
                  v-model="form.app_theme"
                  v-validate="'required'"
                  name="app_theme"
                  data-vv-name="app_theme"
                  label="Tema Luar Aplikasi"
                  data-vv-as="Tema Luar Aplikasi"
                  :error-messages="errors.collect('app_theme')"
                >
                  <template slot="selection" slot-scope="data">
                    <v-chip
                      :selected="data.selected"
                      :class="[!editting ? 'grey' : data.item, 'white--text']"
                      @input="data.parent.selectItem(data.item)"
                    >
                      {{ data.item }}
                    </v-chip>
                  </template>
                  <template slot="item" slot-scope="data">
                    <v-list-tile-avatar :class="data.item" size="30">
                    </v-list-tile-avatar>
                    <v-list-tile-content class="pl-2">
                      <v-list-tile-title>{{ data.item }}</v-list-tile-title>
                    </v-list-tile-content>
                  </template>
                </v-autocomplete>

                <v-card-title class="subheading pl-0 pb-0"
                  >INFORMASI PERUSAHAAN</v-card-title
                >
                <v-divider></v-divider>
                <v-text-field
                  append-icon="business"
                  type="text"
                  :disabled="!editting"
                  v-model="form.company"
                  v-validate="'required'"
                  name="company"
                  data-vv-name="company"
                  label="Nama Perusahaan"
                  data-vv-as="Nama Perusahaan"
                  :error-messages="errors.collect('company')"
                >
                </v-text-field>
                <v-text-field
                  append-icon="email"
                  type="email"
                  :disabled="!editting"
                  v-model="form.company_email"
                  v-validate="'required|email'"
                  name="company_email"
                  data-vv-name="company_email"
                  label="E-Mail Perusahaan"
                  data-vv-as="E-Mail Perusahaan"
                  :error-messages="errors.collect('company_email')"
                >
                </v-text-field>
                <v-text-field
                  append-icon="call"
                  type="text"
                  :disabled="!editting"
                  v-model="form.company_phone"
                  v-validate="'required'"
                  name="company_phone"
                  data-vv-name="company_phone"
                  label="Telepon Perusahaan"
                  data-vv-as="Telepon Perusahaan"
                  :error-messages="errors.collect('company_phone')"
                >
                </v-text-field>
                <v-subheader class="pa-0">DAEMON MAILER</v-subheader>
                <v-text-field
                  append-icon="send"
                  type="text"
                  :disabled="!editting"
                  v-model="form.mailer_sender"
                  v-validate="'required'"
                  name="mailer_sender"
                  data-vv-name="mailer_sender"
                  label="Mailer Sender"
                  data-vv-as="Mailer Sender"
                  :error-messages="errors.collect('mailer_sender')"
                >
                </v-text-field>
                <v-text-field
                  append-icon="markunread_mailbox"
                  type="text"
                  disabled
                  v-model="form.mailer_host"
                  v-validate="'required'"
                  name="mailer_host"
                  data-vv-name="mailer_host"
                  label="Mailer Host"
                  data-vv-as="Mailer Host"
                  :error-messages="errors.collect('mailer_host')"
                >
                </v-text-field>
                <v-text-field
                  append-icon="account_circle"
                  type="email"
                  disabled
                  v-model="form.mailer_username"
                  v-validate="'required|email'"
                  name="mailer_username"
                  data-vv-name="mailer_username"
                  label="Mailer Username"
                  data-vv-as="Mailer Username"
                  :error-messages="errors.collect('mailer_username')"
                >
                </v-text-field>
                <v-text-field
                  append-icon="vpn_key"
                  type="text"
                  disabled
                  v-model="form.mailer_password"
                  v-validate="'required'"
                  name="mailer_password"
                  data-vv-name="mailer_password"
                  label="Mailer Password"
                  data-vv-as="Mailer Password"
                  :error-messages="errors.collect('mailer_password')"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6 class="pa-2">
                <v-card-title class="subheading pl-0 pb-0"
                  >KEBIJAKAN PRIVASI</v-card-title
                >
                <v-divider></v-divider>
                <quill-editor
                  v-model="form.privacy_policy"
                  class="mt-2"
                  :class="{ 'grey--text': !editting }"
                  :disabled="!editting"
                  :options="editorOption"
                >
                </quill-editor>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="pa-3">
            <v-btn v-if="!editting" dark color="primary" @click="edit">
              EDIT
            </v-btn>
            <template v-else>
              <v-btn @click="reset"> BATAL </v-btn>
              <v-btn
                color="primary"
                type="submit"
                :dark="!sameForm"
                :disabled="sameForm"
                @click.prevent="submit"
              >
                SIMPAN
              </v-btn>
            </template>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import _ from "lodash";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import { mapState } from "vuex";

export default {
  name: "sistem",
  components: {
    quillEditor
  },
  data() {
    return {
      form: _.cloneDeep(this.$store.state.sistem.sistem),
      editting: false,
      editorOption: {
        readOnly: true,
        placeholder: "Tulis kebijakan privasi untuk aplikasi ini..",
        theme: "snow"
      },
      colorsOption: [
        "red",
        "pink",
        "purple",
        "indigo",
        "blue",
        "cyan",
        "teal",
        "green",
        "lime",
        "yellow",
        "amber",
        "orange",
        "brown",
        "grey"
      ]
    };
  },
  computed: {
    ...mapState(["status"]),
    ...mapState("sistem", ["sistem"]),
    storeData() {
      return _.cloneDeep(this.sistem);
    },
    sameForm() {
      return _.isEqual(this.sistem, this.form);
    }
  },
  watch: {
    storeData(newValue) {
      this.form = newValue;
    }
  },
  methods: {
    edit() {
      this.editting = true;
      this.$vuetify.goTo(0);
    },
    reset() {
      this.editting = false;
      this.$validator.reset();
      this.form = _.cloneDeep(this.sistem);
    },
    submit() {
      this.$validator.validateAll().then(noError => {
        if (noError) {
          this.$store
            .dispatch("sistem/UPDATE_SISTEM", this.form)
            .then(() => {
              this.reset();
            })
            .catch();
        } else {
          this.$store.commit(
            "ERROR",
            "Ada field yang masih error, cek kembali isian form!"
          );
        }
      });
    }
  },
  mounted() {}
};
</script>
